<template>
  <div id="deliveryConfirm">
    <label class="text_size_big bold">商品情報{{index}}</label>
    <div>
      <section class="input_confirm3">
        <img :src="itemImage" class="item_image">
        <ul>
          <li>
            <div>メーカー名</div>
            <div>{{itemData.makerData.corpName}}</div>
          </li>
          <li>
            <div>シリーズ名</div>
            <div>{{itemData.planEc.ecParamSeriesName}}</div>
          </li>
          <li>
            <div>商品名</div>
            <div>{{itemData.planEc.ecParamProductName}}</div>
          </li>
          <li v-show="isExistStyle">
            <div>スタイル名：</div>
            <div>{{itemData.colorStyle.colorStyleName}}</div>
          </li>
          <li class="list_item3" v-show="isFillerEnable">
            <!-- <div class="text_size_middle bold">
              <label>{{titleNoData.filler}}.{{labelFiller}}</label>
            </div>
            <div class="item_box">
              <label class="bold" v-show="itemData.infoFillerLeft!=undefined">{{labelLeftFiller}}:{{itemData.infoFillerLeft}}mm</label>
              <label class="bold" v-show="itemData.infoFillerRight!=undefined">{{labelRightFiller}}:{{itemData.infoFillerRight}}mm</label>
              <label class="bold" v-show="itemData.infoFillerCenter!=undefined">{{labelCenterFiller}}:{{this.itemData.infoFillerCenter}}mm</label>
            </div> -->
            <div>商品サイズ</div>
            <div>
              <div class="confirm_size">
                <span>W:{{itemData.planEc.ecParamW}}mm</span>
                <span v-if="itemData.planEc.ecParamW2">W2:{{itemData.planEc.ecParamW2}}mm</span>
              </div>
              <div class="confirm_size">
                <span>H:{{itemData.planEc.ecParamH}}mm</span>
                <span v-if="itemData.planEc.ecParamH2">H2:{{itemData.planEc.ecParamH2}}mm</span>
              </div>
              <div class="confirm_size">
                <span>D:{{itemData.planEc.ecParamD}}mm</span>
                <span v-if="itemData.planEc.ecParamD2">D2:{{itemData.planEc.ecParamD2}}mm</span>
              </div>
              <div>
                <span v-show="itemData.planEc.ecParamFillerLeft!=undefined">{{labelLeftFiller}}:{{itemData.planEc.ecParamFillerLeft}}mm</span>
              </div>
              <div>
                <span v-show="itemData.planEc.ecParamFillerRight!=undefined">{{labelRightFiller}}:{{itemData.planEc.ecParamFillerRight}}mm</span>
              </div>
              <div>
                <span v-show="itemData.planEc.ecParamFillerCenter!=undefined">{{labelCenterFiller}}:{{itemData.planEc.ecParamFillerCenter}}mm</span>
              </div>
            </div>
          </li>
          <!-- <li class="list_item3">
            <div class="text_size_middle bold">
              <label>{{titleNoData.size}}.サイズ</label>
            </div>
            <div class="item_box">
              <label class="bold">W:{{itemData.infoW}}mm</label>
              <label class="bold">H:{{itemData.infoH}}mm</label>
              <label class="bold">D:{{itemData.infoD}}mm</label>
            </div>
            <div>
              <div class="main_btn sel_main_btn" @click="onEstimate()">
                <a>図面/見積り</a>
              </div>
            </div>
          </li> -->
          <!-- <li>
            <ul class="color_list">
              <li v-if="itemData.doorColor">
                <dd-color
                  :title="titleNoData.doorColor + '.扉カラー'"
                  :color="doorColor"
                />
              </li>
              <li v-if="itemData.boxColor">
                <dd-color
                  :title="titleNoData.boxColor + '.キャビネット/棚/脚カラー'"
                  :color="boxColor"
                />
              </li>
              <li v-if="itemData.centerColor">
                <dd-color
                  :title="titleNoData.centerColor + '.カウンターカラー'"
                  :color="centerColor"
                />
              </li>
            </ul>
          </li> -->
          <li v-if="itemData.doorColor">
            <div>扉カラー</div>
            <div>{{doorColor.name}}</div>
          </li>
          <li v-if="itemData.boxColor">
            <div>キャビネット/棚/脚カラー</div>
            <div>{{boxColor.name}}</div>
          </li>
          <li v-if="itemData.centerColor">
            <div>カウンターカラー</div>
            <div>{{centerColor.name}}</div>
          </li>
          <li>
            <div>{{optShelfTitle}}</div>
            <div>{{itemData.planEc.ecParamShelfCount}}{{optShelfUnitTitle}}本</div>
          </li>
          <li>
            <div>追加フィラー</div>
            <div>{{itemData.planEc.ecParamFillerCount}}本</div>
          </li>
          <li>
            <div>組立設置</div>
            <div v-if="itemData.planEc.ecInfoOpExFlag===true">あり</div>
            <div v-if="itemData.planEc.ecInfoOpExFlag===false">なし</div>
          </li>
          <li v-if="itemData.planEc.ecInfoOpCarryFlag">
            <div>受け取り搬入サービス</div>
            <div v-if="itemData.planEc.ecInfoOpCarryFlag===true">あり</div>
            <div v-if="itemData.planEc.ecInfoOpCarryFlag===false">なし</div>
          </li>
          <!-- <li class="bold">
            <div>ご注文数</div>
            <div>{{itemData.infoProductCount}}点</div>
            <div>小計（税込）:{{formatPrice(priceData.taxIncludedTotalPrice)}}</div>
          </li> -->
          <!-- <li v-if="itemData.infoCategoryType==4 || itemData.infoCategoryType==10 || itemData.infoCategoryType==11 || itemData.infoCategoryType==12 || itemData.infoCategoryType==13">
            <div class="title_list1">
              <label>この商品は、株式会社みうらが製造し、発送します。</label>
              <ul>
                <li>株式会社みうら</li>
                <li>〒746-0022</li>
                <li>山口県周南市野村3丁目24-1</li>
                <li>TEL.0834-63-8811</li>
              </ul>
              <span class="caution text">※自動メールにて返信しますので{{mailTo}}からのメールを受信許可に設定してください。</span>
            </div>
          </li>
          <li v-else>
            <div class="title_list1">
              <label>この商品は、ファニチャーメーカー株式会社が製造し、発送します。</label>
              <ul>
                <li>ファニチャーメーカー株式会社</li>
                <li>〒151-0053</li>
                <li>東京都渋谷区代々木3-28-6 いちご西参道ビル1F</li>
                <li>TEL.03-6300-9085</li>
                <li>FAX.03-6300-9086</li>
              </ul>
              <span class="caution text">※自動メールにて返信しますので{{mailTo}}からのメールを受信許可に設定してください。</span>
            </div>
          </li> -->
        </ul>
        <div class="order_line">
          <div>ご注文数</div>
          <div>{{itemData.planEc.ecParamProductCount}}点</div>
          <div>小計（税込）:<span>{{formatPrice(priceData.totalTax)}}</span></div>
        </div>
        <div class="detail_btn2" @click="onEstimate()">図面/見積り</div>
      </section>
    </div>
  </div>
</template>
<script>
import * as App from '../../../utils/App'
import * as FormUtil from '../../../utils/FormUtil'
import Color from '../top/input/color/DcColorForCart'
import {DC_STORAGE_KEY, STRUCT_CORP_ID_ST, STRUCT_CORP_ID_ED} from '../../../constants/App'

export default {
  components: {
    'dd-color': Color
  },
  props: {
    index: Number,
    itemData: Object
  },
  data () {
    return {
      titleNoData: {},
      userInfo: {}
    }
  },
  computed: {
    priceData: function () {
      let priceData = {
        itemName: this.itemData.planEc.ecParamProductName,
        itemModelList: this.itemData.planEc.ecSnapPriceDetail,
        itemPrice: this.itemData.planEc.ecSnapItemPrice,
        itemDeliPrice: this.isHaseko ? this.itemData.planEc.ecSnapItemPrice + this.itemData.planEc.ecSnapDeliveryPrice : this.itemData.planEc.ecSnapItemPrice,
        constructPrice: this.itemData.planEc.ecSnapConstructPrice,
        subTotalPrice: this.itemData.planEc.ecSnapSubTotalPrice,
        subTotalTax: this.itemData.planEc.ecSnapSubTotalTax,
        delivaryPrice: this.itemData.planEc.ecSnapDeliveryPrice,
        taxPrice: this.itemData.planEc.ecSnapTaxPrice,
        totalPrice: this.itemData.planEc.ecSnapPrice,
        totalTax: this.itemData.planEc.ecSnapTaxIncludedTotalPrice,
        executionVarExpensesPrice: this.itemData.planEc.ecSnapExecutionVarExpensesPrice,
        carryInPrice: this.itemData.planEc.ecSnapCarryInPrice,
        constructTotalPrice: this.itemData.planEc.ecSnapOptionSubTotalPrice,
        constructTotalTax: this.itemData.planEc.ecSnapOptionSubTotalTax,
        productCount: this.itemData.planEc.ecParamProductCount,
        profitPercent: 100
      }
      return priceData
    },
    doorColor: function () {
      if (!this.itemData.doorColor) return
      let bigName = FormUtil.bigImage(this.itemData.doorColor.img)
      let color = {
        id: this.itemData.doorColor.no,
        name: this.itemData.doorColor.name,
        type: this.itemData.doorColor.type,
        no: this.itemData.doorColor.dispNo,
        img: this.getImage('color/' + this.itemData.doorColor.img),
        imgB: this.getImage('color/' + bigName)
      }
      return color
    },
    boxColor: function () {
      if (!this.itemData.boxColor) return
      let bigName = FormUtil.bigImage(this.itemData.boxColor.img)
      let color = {
        id: this.itemData.boxColor.no,
        name: this.itemData.boxColor.name,
        type: this.itemData.boxColor.type,
        no: this.itemData.boxColor.dispNo,
        img: this.getImage('color/' + this.itemData.boxColor.img),
        imgB: this.getImage('color/' + bigName)
      }
      return color
    },
    centerColor: function () {
      if (!this.itemData.centerColor) return
      let bigName = FormUtil.bigImage(this.itemData.centerColor.img)
      let color = {
        id: this.itemData.centerColor.no,
        name: this.itemData.centerColor.name,
        type: this.itemData.centerColor.type,
        no: this.itemData.centerColor.dispNo,
        img: this.getImage('color/' + this.itemData.centerColor.img),
        imgB: this.getImage('color/' + bigName)
      }
      return color
    },
    makerData: function () {
      if (!this.itemData.makerData) return undefined
      let makerData = {
        corpName: this.itemData.makerData.corpName,
        postcd: this.itemData.makerData.postcd,
        address: ((this.itemData.makerData.state ? this.itemData.makerData.state : '') +
          (this.itemData.makerData.city ? this.itemData.makerData.city : '') +
          (this.itemData.makerData.street ? this.itemData.makerData.street : '')),
        tel: this.itemData.makerData.tel,
        fax: this.itemData.makerData.fax
      }
      return makerData
    },
    isFillerEnable: function () {
      return this.itemData.planEc.ecParamFillerLeft !== undefined ||
        this.itemData.planEc.ecParamFillerRight !== undefined ||
        this.itemData.planEc.ecParamFillerCenter !== undefined
    },
    mailTo: function () {
      if (this.itemData.planEc.ecInfoOpExFlag) {
        return '「@domans.co.jp」、「@candeal.co.jp」'
      } else {
        return '「@domans.co.jp」'
      }
    },
    labelFiller: function () {
      if (this.itemData.planEc.ecSnapCategoryType === 4) return '壁埋め込み'
      return 'フィラー'
    },
    labelLeftFiller: function () {
      if (this.itemData.planEc.ecSnapCategoryType === 4) return '左壁埋め込み'
      return '左フィラー'
    },
    labelRightFiller: function () {
      if (this.itemData.planEc.ecSnapCategoryType === 4) return '右壁埋め込み'
      return '右フィラー'
    },
    labelCenterFiller: function () {
      if (this.itemData.planEc.ecSnapCategoryType === 4) return '奥壁埋め込み'
      return '上部フィラー'
    },
    itemImage: function () {
      if (!this.itemData || !this.itemData.planEc.ecSnapProductImage) return this.getImage('noimage.svg')
      return this.getImage(this.bigImage(this.itemData.planEc.ecSnapProductImage))
    },
    optShelfTitle: function () {
      if (this.itemData.planEc.ecSnapCategoryType === 5) return 'ご注文数'
      return '追加可動棚'
    },
    optShelfUnitTitle: function () {
      if (this.itemData.planEc.ecSnapCategoryType === 5) return '枚'
      return '枚/列'
    },
    isExistStyle: function () {
      if (!this.itemData.colorStyle) return false
      if (!this.itemData.colorStyle.colorStyleId) return false
      return true
    },
    isHaseko: function () {
      return (this.userInfo && this.userInfo.corpId >= STRUCT_CORP_ID_ST && this.userInfo.corpId <= STRUCT_CORP_ID_ED)
    },
    targetPlan: function () {
      let payload = {
        dcWidth: this.itemData.planEc.ecParamW,
        dcWidth2: this.itemData.planEc.ecParamW2,
        dcHeight: this.itemData.planEc.ecParamH,
        dcHeight2: this.itemData.planEc.ecParamH2,
        dcDepth: this.itemData.planEc.ecParamD,
        dcDepth2: this.itemData.planEc.ecParamD2,
        dcBType: this.itemData.planEc.ecParamFillerLeft ? 1 : 0,
        dcBSize: this.itemData.planEc.ecParamFillerLeft,
        dcCType: this.itemData.planEc.ecParamFillerRight ? 1 : 0,
        dcCSize: this.itemData.planEc.ecParamFillerRight,
        dcDType: this.itemData.planEc.ecParamFillerCenter ? 1 : 0,
        dcDSize: this.itemData.planEc.ecParamFillerCenter,
        dcShelfCount: this.itemData.planEc.ecParamShelfCount,
        dcFillerCount: this.itemData.planEc.ecParamFillerCount
      }
      return payload
    }
  },
  methods: {
    setTitleNo: function () {
      let count = 1
      this.$set(this.titleNoData, 'filler', count++)
      this.$set(this.titleNoData, 'size', count++)
      if (this.itemData.doorColor && Object.keys(this.itemData.doorColor).length > 0) {
        this.$set(this.titleNoData, 'doorColor', count++)
      }
      if (this.itemData.boxColor && Object.keys(this.itemData.boxColor).length > 0) {
        this.$set(this.titleNoData, 'boxColor', count++)
      }
      if (this.itemData.centerColor && Object.keys(this.itemData.centerColor).length > 0) {
        this.$set(this.titleNoData, 'centerColor', count++)
      }
      this.$set(this.titleNoData, 'construct', count++)
      this.$set(this.titleNoData, 'price', count++)
    },
    onEstimate: function () {
      let estimateData = {
        fileName: this.itemData.planEc.ecParamProductName,
        titleDoor: '扉カラー',
        colorDoor: this.doorColor,
        titleCabine: 'キャビネット/棚/脚カラー',
        colorCabine: this.boxColor,
        titleCounter: 'カウンターカラー',
        colorCounter: this.centerColor,
        priceData: this.priceData,
        targetPlan: this.targetPlan,
        spaceJoincd: this.itemData.planEc.ecParamSpaceJoincd,
        dcProductCount: this.itemData.planEc.ecParamProductCount,
        isDrawing: this.itemData.planEc.ecSnapCategoryType !== 5,
        makerData: this.itemData.makerData,
        isNetPrice: this.isHaseko
      }
      this.$emit('onShowEstimateModal', estimateData)
    },
    getImage: function (image) {
      return App.getMmstyleResource(image)
    },
    bigImage: function (imgName) {
      let index = String(imgName).indexOf('.')
      let file = String(imgName).substring(0, index)
      let exp = String(imgName).substring(index, imgName.length)
      return file + '_B' + exp
    },
    formatPrice: function (price) {
      if (!price) return '￥0'
      let ret = String(price).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')
      return '￥' + ret
    }
  },
  mounted: function () {
  },
  created: function () {
    this.userInfo = App.getLocalStorage(DC_STORAGE_KEY.USER_INFO)
    this.setTitleNo()
  }
}
</script>
<style src="../../css/dc-order.scss" lang="scss" scoped></style>
<style src="../../css/print.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/payment/components/order/DcItemConfirm.vue